<div id="site" class="d-flex align-items-center bg-auth border-top border-top-2 border-primary h-100">

  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 col-md-5 col-xl-4 my-5">

        <div class="text-center">
          <img src="/assets/img/logo-enwa.png" />
        </div>
        <!-- Heading -->
        <!--<h1 class="display-4 text-center mb-3">
          Anmelden
        </h1>-->
        <!-- Subheading -->
        <p class="text-muted text-center mb-5">
          Herzlich Willkommen.
        </p>

        <!-- Form -->
        <form *ngIf="showLoginCard === true">

          <!-- Email address -->
          <div class="form-group">

            <!-- Label -->
            <label>Email Adresse oder Gerätenummer</label>

            <!-- Input -->
            <input type="email" name="eMail" [(ngModel)]="eMail" class="form-control" placeholder="name@address.com">

          </div>

          <!-- Password -->
          <div class="form-group">

            <div class="row">
              <div class="col">

                <!-- Label -->
                <label>Passwort</label>

              </div>
              <div class="col-auto">

                <!-- Help text -->
                <a routerLink="/password-reset" class="form-text small text-muted">
                  Passwort vergessen?
                </a>

              </div>
            </div> <!-- / .row -->
            <!-- Input group -->
            <div class="input-group input-group-merge">
              <!-- Input -->
              <!--<input type="password" name="password" [(ngModel)]="password" class="form-control form-control-appended" placeholder="Passwort eingeben">-->
              <input [type]="fieldTextType ? 'text' : 'password'"
                     name="password"
                     [(ngModel)]="password"
                     class="form-control form-control-appended"
                     placeholder="Passwort eingeben">

              <!-- Icon -->
              <div class="input-group-append">
                <span class="input-group-text">
                  <i [ngClass]="fieldTextType ? 'fa fa-eye' : 'fa fa-eye-slash'" (click)="toogleFieldTextTytpe()"></i>
                </span>
              </div>

            </div>
          </div>

          <div class="alert alert-danger" *ngIf="error">
            {{error}}
          </div>

          <!-- Submit -->
          <button class="btn btn-lg btn-block btn-primary mb-3" (click)="submit()" [disabled]="isSubmitted">
            {{isSubmitted? 'Sie werden angemeldet' : 'Anmelden'}}
          </button>

        </form>

      </div>
    </div> <!-- / .row -->
  </div>

</div>
